import { Skeleton } from 'antd';
import { memo } from 'react';
import AC from '../AccessControl';
import styles from './AppCard.module.scss';
const ImgSize = 70; // in px

const CardContent = memo(({
  icon,
  text
}) => <>
    <div className={styles['card-image']} children={icon} />
    <div className={styles['card-text']} children={text} />
  </>);
const Loading = memo(() => <span className={styles['appcard-container']} children={<CardContent icon={<Skeleton.Image active style={{
  width: ImgSize,
  height: ImgSize
}} />} text={<Skeleton active title={false} paragraph={{
  rows: 3,
  style: {
    margin: 0,
    padding: 0
  }
}} />} />} />);
const Content = memo(({
  name,
  subname,
  iconUrl,
  gradeRangeName
}) => <CardContent icon={<img src={iconUrl} width={ImgSize} height={ImgSize} />} text={<>
        <div className={styles['label']} children={name} />
        {subname && <div className={styles['subtitle']} children={subname} />}
        {gradeRangeName && <div className={styles['grade-tag']} children={gradeRangeName} />}
      </>} />);
const AppCard = ({
  app: {
    id,
    url,
    ...rest
  }
}) => {
  const card = <Content {...rest} />;
  return <AC.CheckAccess rule={{
    action: 'curriculum',
    object: 'access',
    args: [{
      id
    }]
  }} loadType={<Loading />} children={<a href={url} className={styles['appcard-container']} children={card} />} ifCant={<span className={`${styles['appcard-container']} ${styles['locked']}`}>
          <img src="/assets/lock-icon.png" className={styles['lock-icon']} />
          {card}
        </span>} data-sentry-element="unknown" data-sentry-component="AppCard" data-sentry-source-file="AppCard.jsx" />;
};
export default AppCard;